interface StreamingRowBehaviorOptions {
  isStreaming: boolean;
  isDbAiFirstCreationEnabled: boolean;
  isAiFieldStreaming: boolean;
  entryId: string;
  entryIdSelectedForProcessing: string | undefined;
}

interface StreamingEntryScrollTargetOptions {
  activeBackendAgentEntryId: string | undefined;
  entryIdSelectedForProcessing: string | undefined;
  isAiFieldStreaming: boolean;
  isDbAiFirstCreationEnabled: boolean;
  isStreaming: boolean;
}

interface StreamingEntryScrollModeOptions {
  renderedEntryIds: ReadonlySet<string>;
  target: Exclude<StreamingEntryScrollTarget, { kind: 'none' }>;
}

export type StreamingEntryScrollTarget =
  | { kind: 'none' }
  | { entryId: string; kind: 'aifc' }
  | { entryId: string; kind: 'backendAgent' };

export const getStreamingEntryScrollTarget = ({
  activeBackendAgentEntryId,
  entryIdSelectedForProcessing,
  isAiFieldStreaming,
  isDbAiFirstCreationEnabled,
  isStreaming
}: StreamingEntryScrollTargetOptions): StreamingEntryScrollTarget => {
  if (isStreaming && (isDbAiFirstCreationEnabled || isAiFieldStreaming)) {
    return entryIdSelectedForProcessing
      ? { entryId: entryIdSelectedForProcessing, kind: 'aifc' }
      : { kind: 'none' };
  }

  return activeBackendAgentEntryId
    ? { entryId: activeBackendAgentEntryId, kind: 'backendAgent' }
    : { kind: 'none' };
};

export const getStreamingEntryScrollMode = ({
  renderedEntryIds,
  target
}: StreamingEntryScrollModeOptions): 'element' | 'none' | 'position' => {
  if (target.kind === 'backendAgent') {
    return 'element';
  }

  return renderedEntryIds.has(target.entryId) ? 'none' : 'position';
};

export const getStreamingRowBehavior = ({
  isStreaming,
  isDbAiFirstCreationEnabled,
  isAiFieldStreaming,
  entryId,
  entryIdSelectedForProcessing
}: StreamingRowBehaviorOptions) => {
  const isTargetStreamingRow = isStreaming && entryId === entryIdSelectedForProcessing;

  return {
    shouldShowAifcStreamingVisuals:
      isTargetStreamingRow && isDbAiFirstCreationEnabled && !isAiFieldStreaming,
    shouldAutoScrollToStreamingRow:
      isTargetStreamingRow && (isDbAiFirstCreationEnabled || isAiFieldStreaming)
  };
};
